import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import useHelper from 'hook/useHelper';
import { useState } from 'react';
import { useSelector } from 'react-redux';

import './LeftValue.scss'
import { options } from './LeftValueConfig';

export default function LeftValue(props: any) {
  const [FilterLabel, setFilterLabel] = useState<any>([])
  const { handleFilterArray } = useHelper();
  const time = props?.time
  const CommnonStore = useSelector((state: any) => state?.CommnonStore)
  const ChartStore = useSelector((state: any) => state?.ChartStore)

  let fontSizeLabel = '14px';
  let height = 473;
  if (CommnonStore?.innerWidthScreen > 1440) {
    height = 473
  } else if (CommnonStore?.innerWidthScreen > 1200) {
    height = 350
  } else if (CommnonStore?.innerWidthScreen < 700) {
    fontSizeLabel = '10px'
    height = 200
  }

  const handleChangeFilterLabel = (value: string) => {
    const FilterLabelNew: any = handleFilterArray(value, FilterLabel)
    setFilterLabel([...FilterLabelNew])
  }

  return (
    <>
      <div className='uRiKRQTlTd'>
        <div className='QdKnxOdyKj'>
          <div className='ltbrzmpyru'>Giá cổ phiếu</div>
          <div className='hxuwwthxne'>{ChartStore?.values?.pb ? 'P/B' : ''}{ChartStore?.values?.pe ? 'P/E' : ''}</div>
          <HighchartsReact
            highcharts={Highcharts}
            options={options(ChartStore?.values, time, height, fontSizeLabel, FilterLabel)}
          />
        </div>
        <div className='rzuxgkjhyu'>
          <div className={`tivnwxskuv`} onClick={() => handleChangeFilterLabel('Giá cổ phiếu')}>
            <div className='tpbrgdqbkx' style={FilterLabel.indexOf("Giá cổ phiếu") > -1 ? { backgroundColor: '#22AB24' } : { border: '2px solid #22AB24' }}>
            </div>Giá cổ phiếu</div>
          <div className={`tivnwxskuv ${FilterLabel.indexOf("P/E") > -1}`} onClick={() => handleChangeFilterLabel('P/E')}>
            <div className='tpbrgdqbkx' style={FilterLabel.indexOf("P/E") > -1 ? { backgroundColor: '#F2994A' } : { border: '2px solid #F2994A' }}>
            </div>{ChartStore?.values?.pb ? 'P/B' : ''}{ChartStore?.values?.pe ? 'P/E' : ''}</div>
        </div>
      </div>
    </>
  )
}